import { KeyboardShortcuts } from "@nova/component-keyboard-shortcuts"
import { InspectorPanelAccordion } from "features/map/inspector-panel/accordion/InspectorPanelAccordion"
import * as Icons from "@nova/component-icons"
import { memo } from "react"

const FirePerimeterManualKeyboardShortcuts = memo(
    ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }) => {
        return (
            <InspectorPanelAccordion
                title="Keyboard Shortcuts"
                isOpen={isOpen}
                setIsOpen={(isOpen) => setIsOpen(isOpen)}
                shouldPadChildrenVertically={false}
                extraVerticalPaddingInRem={0}
            >
                <div className="-mx-2 px-2 my-2 flex flex-col gap-1">
                    <KeyboardShortcuts
                        shortcuts={[
                            {
                                title: "Place / Draw",
                                mac: [Icons.KeyboardLeftClick],
                                windows: [Icons.KeyboardLeftClick],
                            },
                            {
                                title: "Delete Vertex",
                                mac: ["delete"],
                                windows: [Icons.KeyboardBackspace],
                            },
                            {
                                title: "Undo",
                                mac: [Icons.KeyboardCommand, "Z"],
                                windows: ["Ctrl", "Z"],
                            },
                            {
                                title: "Redo",
                                mac: [Icons.KeyboardCommand, Icons.KeyboardShift, "Z"],
                                windows: ["Ctrl", "Y"],
                            },
                            {
                                title: "Reset",
                                mac: [Icons.KeyboardCommand, "delete"],
                                windows: ["Ctrl", Icons.KeyboardBackspace],
                            },
                            {
                                title: "Finish",
                                mac: ["return"],
                                windows: ["Enter"],
                            },
                        ]}
                    />
                </div>
            </InspectorPanelAccordion>
        )
    }
)
FirePerimeterManualKeyboardShortcuts.displayName = "FirePerimeterManualKeyboardShortcuts"
export { FirePerimeterManualKeyboardShortcuts }
